import { BiSolidDashboard } from "react-icons/bi";
import { PiLinkFill } from "react-icons/pi";
import logo from "../logo.png";
import { IoIosListBox } from "react-icons/io";
import { MdOutlineHistory, MdSwapHoriz } from "react-icons/md";
import { IoWallet } from "react-icons/io5";

const navList = [
  { label: 'Dashboard', name: 'dashboard', icon: BiSolidDashboard },
  { label: 'Remote Accounts', name: 'remote', icon: PiLinkFill },
  { label: 'Credits', name: 'credits', icon: IoWallet },
  { label: 'Transactions', name: 'transaction', icon: IoIosListBox },
  { label: 'Connection Logs', name: 'logs', icon: MdOutlineHistory },
];

export default function LeftNav({ nav, className, onNavigate }: any) {
  return (

    <nav className={`h-full w-[264px] shrink-0 flex flex-col border-r border-slate-200 bg-white ${className ? className : ''}`}>

      <a
        href="https://kptd.ph/remote"
        className="shrink-0 flex flex-row items-center gap-3 px-5 py-5">
        <img className="h-10 w-10 rounded-xl ring-1 ring-slate-200" src={logo} alt="" />
        <span className="flex flex-col leading-tight">
          <span className="text-[15px] font-bold tracking-tight text-slate-900">Remote VPN</span>
          <span className="text-[11px] text-slate-400">by KPTD</span>
        </span>
      </a>

      <div className="mx-5 h-px bg-slate-100"></div>

      <div className="grow flex flex-col gap-1 overflow-y-auto p-3 thin-scroll">

        <div className="px-3 pb-1 pt-3 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-400">
          Menu
        </div>

        {navList.map((item: any, index: number) => {
          const active = nav === item.name;
          return (
            <a
              href={`/${item.name}`}
              key={`${index}-nav`}
              onClick={onNavigate}
              className={`shrink-0 flex flex-row items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition ${active
                ? 'bg-emerald-600 font-semibold text-white shadow-sm shadow-emerald-600/25'
                : 'font-medium text-slate-500 hover:bg-slate-100 hover:text-slate-900'}`}>
              <item.icon size={18} className={`shrink-0 ${active ? 'text-white' : 'text-slate-400'}`} />
              <span className="truncate">{item.label}</span>
            </a>
          );
        })}

        {/* Opens the MikRouter account migration page (replaces the old top banner). */}
        <a
          href="https://mikrouter.com/user/migrate"
          target="_blank"
          rel="noreferrer"
          onClick={onNavigate}
          className="shrink-0 flex flex-row items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-slate-500 transition hover:bg-slate-100 hover:text-slate-900">
          <MdSwapHoriz size={18} className="shrink-0 text-slate-400" />
          <span className="truncate">Migrate</span>
          <span className="ml-auto shrink-0 rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-emerald-700">
            New
          </span>
        </a>

      </div>

      <div className="shrink-0 border-t border-slate-200 p-3">
        <div className="rounded-xl bg-slate-50 px-3 py-2.5 ring-1 ring-slate-100">
          <div className="text-[11px] font-semibold text-slate-600">Remote VPN</div>
          <div className="text-[11px] text-slate-400">Version {process.env.REACT_APP_VERSION}</div>
        </div>
      </div>

    </nav>
  )
}
